import React from "react";
import ReactDOM from "react-dom/client";
// import { StrictMode } from "react";
// import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { CartProvider } from "./context/CartContext.tsx";
import { MessageModalProvider } from "./admin/contexts/MessageModalContext.tsx";
import { PromotionBannerProvider } from "./admin/contexts/PromotionBannerContext.tsx";
import { TopSellingProductsProvider } from "./admin/contexts/TopSellingProductsContext.tsx";
import { SiteSearchProvider } from "./context/SiteSearchContext";
import { PreviousBuyingProvider } from "./admin/contexts/PreviousBuyingContext.tsx";
import { BusyProvider } from "./context/BusyContext.tsx";
import FacebookPixel from "./components/FacebookPixel.tsx";
import { FormatProvider } from "./context/FormatContext";
import { CurrencyConverterProvider } from "./context/CurrencyConverterContext.tsx";
import { BubbleModalProvider } from "./context/BubbleModalContext.tsx";
import "./assets/bootstrap/bootstrap.min.css";
import "./assets/font-awesome-4.7.0/css/font-awesome.min.css";
import "./assets/font-awesome-4.7.0/css/font-awesome.css";
import "./assets/animate/animate.min.css";
// import "./assets/style.default.css";
import "./assets/font-icon-style.css";
import "./assets/owl-carousel/owl.carousel.min.css";
import "./assets/owl-carousel/owl.theme.default.min.css";
import "./assets/style.css";
import "./assets/Header.css";
import "./assets/services.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <FormatProvider>
      <CurrencyConverterProvider>
        <CartProvider>
          <MessageModalProvider>
            <PromotionBannerProvider>
              <SiteSearchProvider>
                <TopSellingProductsProvider>
                  <PreviousBuyingProvider>
                    <FacebookPixel>
                      <BusyProvider>
                        <BubbleModalProvider>
                          <App />
                        </BubbleModalProvider>
                      </BusyProvider>
                    </FacebookPixel>
                  </PreviousBuyingProvider>
                </TopSellingProductsProvider>
              </SiteSearchProvider>
            </PromotionBannerProvider>
          </MessageModalProvider>
        </CartProvider>
      </CurrencyConverterProvider>
    </FormatProvider>
  </React.StrictMode>,
);
